import { ComplexEnum } from '../../utils/complexEnum'
import {
  AsphaltMixDesign,
  ConcreteMixDesign,
  ConstructionAdminSubmittal,
  DesignSubmittal,
  FieldDesignChanges,
  IdentifiedFieldIssue,
  Issue,
  PayItemNoGeometry,
  RequestForInformation,
} from './instances'

export type CSVEntityItem =
  | typeof ConcreteMixDesign
  | typeof DesignSubmittal
  | typeof ConstructionAdminSubmittal
  | typeof FieldDesignChanges
  | typeof IdentifiedFieldIssue
  | typeof Issue
  | typeof RequestForInformation
  | typeof AsphaltMixDesign
  | typeof PayItemNoGeometry

class CSVEntityEnum extends ComplexEnum<
  'CSVEntity',
  CSVEntityItem,
  CSVEntityItem['id']
> {
  typename = 'CSVEntity' as const
  readonly ConcreteMixDesign = ConcreteMixDesign
  readonly DesignSubmittal = DesignSubmittal
  readonly ConstructionAdminSubmittal = ConstructionAdminSubmittal
  readonly FieldDesignChanges = FieldDesignChanges
  readonly IdentifiedFieldIssue = IdentifiedFieldIssue
  readonly Issue = Issue
  readonly RequestForInformation = RequestForInformation
  readonly AsphaltMixDesign = AsphaltMixDesign
  readonly PayItemNoGeometry = PayItemNoGeometry
  get values() {
    return [
      this.ConcreteMixDesign,
      this.DesignSubmittal,
      this.ConstructionAdminSubmittal,
      this.FieldDesignChanges,
      this.IdentifiedFieldIssue,
      this.Issue,
      this.RequestForInformation,
      this.AsphaltMixDesign,
      this.PayItemNoGeometry,
    ]
  }
}

export const CSVEntity = new CSVEntityEnum()
